import { ProjectDayHours } from '../types/projectDayHoursTypes';
import apiClient from './apiClient';

export const getProjectDayHours = async (projectId: number): Promise<ProjectDayHours[]> => {
  const response = await apiClient.get(`/project-day-hours/project/${projectId}`);
  return response.data;
};

export const createProjectDayHours = async (dayHours: ProjectDayHours): Promise<ProjectDayHours> => {
  const response = await apiClient.post('/project-day-hours', dayHours);
  return response.data;
};

export const updateProjectDayHours = async (dayHours: ProjectDayHours): Promise<ProjectDayHours> => {
  const response = await apiClient.put(`/project-day-hours/${dayHours.id}`, dayHours);
  return response.data;
};

export const deleteProjectDayHours = async (id: number): Promise<void> => {
  await apiClient.delete(`/project-day-hours/${id}`);
};
